<template>
    <div class="wrapper" @click="globalClick">
        <h1 class="title">
            <span>Basic Information</span>
            <p class="guide">
                Step <em>{{ route.query.step }}</em> / {{ route.query.as }}
            </p>
        </h1>
        
        <!-- <Dropdonw 
            title="Name"
            :choics=[]
        >

        </Dropdonw> -->
        
        <div class="content">
            <div class="element-container" v-for="(item, ind) in obj.select_types" :key="ind">
                <template v-if="item.dataType=='0'">
                    <Dropdonw
                        :title="item.key"
                        :required="item.checkReq"
                        :choices="item.dictionaryVoList"
                        :keys="item.value"    
                        :is_show="item.is_show" 
                        :is_error="item.is_error"
                        :label="item.label"              
                        :component_id = "ind"                    
                        fromPage = "baseinfo_page"
                        :requestId = "requestId"
                        @modify="modify_dropdown"
                        @modifyError="modify_error"
                        @setValue="setValue"
                    >
                    </Dropdonw>        
                </template>
                <template  v-if="item.dataType=='1'">
                    <MyInput
                        :title="item.key"
                        :component_id = ind
                        :required="item.checkReq"
                        :keys="item.value"
                        :label="item.label"
                        :is_show="item.is_show"
                        :is_error="item.is_error"
                        :checkType="item.checkType"
                        :maxlength="item.lengthLimitMax"
                        fromPage = "baseinfo_page"
                        :eventCount = item.eventCount
                        :requestId = "requestId"
                        @setCount="setCount"
                        @modifyError="modify_error"
                        @setValue="setValue"
                        @refreshRequestId="refreshRequestId"
                    >
                    </MyInput>
                </template>
                <template  v-if="item.dataType=='4'">
                    <State
                        :title="item.key"
                        :required="item.checkReq"
                        :component_id = ind
                        :keys="item.value"
                        :is_error="item.is_error"
                        :is_show="item.is_show"
                        :label="item.label"
                        @setValue="setValue"
                        @modify="modify_normal"
                        @modifyError="modify_error"
                    >
                    </State>
                </template>
                <template  v-if="item.dataType=='5'">
                    <Location
                        :title="item.key"
                        :required="item.checkReq"
                        :component_id = ind
                        :keys="item.value"   
                        :label="item.label"   
                        :is_error="item.is_error"                  
                        :is_show="item.is_show"
                        :state_id = "state_id"
                        @setValue="setValue"
                        @modify="modify_normal" 
                        @modifyError="modify_error"                   
                    >
                    </Location>
                </template>
                
            </div>            
        </div>        
        <div class="placeholder"></div>
        <div class="btn-container">            
            <a class='btn-submit' :class='{"unactive":!btnStatus}' @click="submit">CONFIRM TO NEXT</a>
        </div>
    </div>
</template>
<style lang="less" scoped>
    .wrapper{
        padding:40px;        
        .title{
            display: flex;
            justify-content: space-between;
            align-items: center;
            color:#FFA368;
            font-size: 40px;
            margin: 0 0 50px 0;  
            .guide{
                color:#A59BB3;
                font-size: 30px;
                em{
                    color:#FFA368;
                    font-weight: 700;
                }
            }
        }
    }
    .btn-container{
        position: fixed;
        left:0;
        bottom: 0;        
        background:#fff;
        padding:40px;
        // padding:40px;
        .btn-submit{
            display: block;
            width: 670px;
            height: 96px;
            line-height: 96px;
            text-align: center;
            border-radius: 12px;
            background:#FFA368;
            font-size: 32px;
            margin:0 auto;
            color:#fff;
            &.unactive{
                background:#f0f0f0;
                color:#999
            }
        }
    }
    .placeholder{
        height: 176px;        
    }
</style>
<script>

import { reactive, onMounted, computed, ref , getCurrentInstance, onBeforeMount, onBeforeUnmount} from 'vue'
import { base_info, base_submit } from '@api/index'
import Dropdonw from '@/components/business/kyc/dropdown.vue'
import MyInput from '@/components/business/kyc/input.vue'
import State from '@/components/business/kyc/state.vue'
import Location from '@/components/business/kyc/location.vue'
import { useRouter } from 'vue-router'
import { useLoading } from 'vue-loading-overlay'
import { v4 as uuidv4} from 'uuid'
import { useStore } from 'vuex'
export default {
    components:{
        Dropdonw,
        MyInput,
        State,
        Location
    },    
    setup () {
        const router = useRouter()
        const route = router.currentRoute
        const clicked = ref(false)
        const btnStatus = ref(false)
        const proxy  = getCurrentInstance().proxy
        const store = useStore()
        let obj = reactive({
            select_types:[],
            input_types:[],
            state_types:[],
            district_types:[],            
            params:{}
        })
        const requestId = ref(uuidv4())
        const state_id = computed(()=>{
            return obj.params['liveState'].value
        })
        const validate = () => {
            let res = true
            for(let x in obj.params){
                if (obj.params[x].value == '') {
                    obj.select_types[obj.params[x].ind].is_error = false
                    res = false
                }
            }
            btnStatus.value = res
            return res
        }
        const $loading = useLoading()
        const globalClick = () => {           
            for (let x in obj.select_types){                
                if(obj.select_types[x].is_show && obj.select_types[x]['dataType'] == '0'){
                    uploadBury('complete', obj.params[obj.select_types[x]['value']].value, 1, x)
                    requestId.value = uuidv4()
                }
                obj.select_types[x].is_show = false
            }
        }
        onBeforeMount(()=>{
            store.dispatch('bury', {eventId:"base_info_page_view"})
            store.dispatch("clearBuryCache", [])
        })
        onBeforeUnmount(()=>{
            store.dispatch('bury', {eventId:"base_info_exit_page_tech"})
            store.dispatch("clearBuryCache", [])
        })
        const uploadBury = (type, value, numberTimes,x ) => {
            try {
                store.dispatch('buryCache', { 'event_id':  obj.select_types[x]['event_target'][type], value:value, requestId:requestId, numberTimes:numberTimes})           
            } catch (error) {
                console.log(error)    
            }
        }
        const submit = () => {            
            if(validate() && !clicked.value){
                clicked.value = true
                let loader = $loading.show({
                    container:null
                })
                let newParams = {}
                for(let i in obj.params) {
                    newParams[i] = obj.params[i].value
                }
                store.dispatch("bury",{"event_id":"base_info_enter_button_click"})
                base_submit(newParams).then((res)=>{
                    if(res.code == 0) {
                        store.dispatch("bury",{"event_id":"base_info_enter_button_click_success"})
                        store.dispatch("uploadBury")
                        router.push({
                            "path":"/auth/index",
                            "query":{
                                "pid":route.value.query.pid
                            }
                        })
                    } else {
                        let error_text = ""
                        for(let i = 0 ; i<res.data.errorColumn.length;i++) {
                            error_text += `${i+1}.  ${res.data.errorColumn[i].msg} \n`
                        }
                        proxy.$toast.show(error_text)
                    }
                    loader.hide()
                    clicked.value = false
                }).catch(()=>{
                    clicked.value = false
                })
            }
        }
        onMounted(async () => {
            const loader = proxy.$loading.show({
                container:null
            })
            let data = await base_info()
            loader.hide()
            let select_type = data.data.map((ele, ind)=>{
                ele.is_show = false
                ele.is_error = false
                if(ele.dataType == '0'|ele.dataType == '4'|ele.dataType == '5') {
                    ele.label = ele.label?ele.label:"Please select"
                } else if (ele.dataType == '1') {
                    ele.label = ele.label?ele.label:"Please input"
                } 
                if(ele.checkReq == 0) {
                    obj.params[ele.value] = {
                        "value":'',
                        "ind": ind,
                        "required":true
                    }
                    
                } else {
                    obj.params[ele.value] = {
                        "value":'',
                        "ind": ind,
                        "required":0
                    }
                }
                ele.event_target = store.state.buryConfig['baseinfo_page'][ele.value] || ""
                if(ele.dataType == '1') {
                    ele.eventCount = 0
                }           
                return ele
            })
            // .filter(element => {
            //     return element.dataType == '0'            
            // })
            obj.select_types = select_type.map((ele, ind)=>{
                ele.is_show = false                
                ele.is_error = false
                obj.params[ele.value] = {
                    "value":'',
                    "ind": ind
                }
                return ele
            })                        
        })
        const modify_normal = (k, v) => {
            for (let x in obj.select_types){                
                obj.select_types[x].is_show = false
            }
            obj.select_types[k]['is_show'] = v           
        }
        const modify_dropdown = (k, v, dictValue,uid,event_id) => {        
            setTimeout(()=>{
                obj.select_types[k]['is_show'] = v 
                if(v){
                    store.dispatch('buryCache', { 
                        'event_id':  event_id, 
                        'value': dictValue, 
                        requestId:uid,
                        numberTimes:0
                    })
                    console.log(2)
                } else {
                    store.dispatch('buryCache', { 
                        'event_id':  event_id, 
                        value:dictValue, 
                        requestId:uid, 
                        numberTimes:1
                    })
                    refreshRequestId()   
                }  
            })
                  
                           
        }
        const setCount = (ind, count) => {
            obj.select_types[ind].eventCount = count
        }
        const refreshRequestId = () => {
            requestId.value = uuidv4()
        }                
        const modify_error = (k,v) =>{
            v = false
            obj.select_types[k]['is_error'] = v
        }
        const setValue = (k, v) => {               
            obj.params[k].value = v
            validate()
        }                
        return {
            obj,
            setValue ,
            requestId,
            modify_normal,
            state_id,
            submit,
            modify_error,
            btnStatus,
            route,
            globalClick,
            setCount,
            refreshRequestId,
            modify_dropdown
        }
    }
}
</script>
